import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETRMASettingsResponse, RMASettings } from '@cbgms/api'
import * as requests from '@cbgms/api/modules/rma/requests'

const GET_RETURN_SETTINGS = 'GET_RETURN_SETTINGS'
const GET_RETURN_SETTINGS_SUCCESS = 'GET_RETURN_SETTINGS_SUCCESS'
const GET_RETURN_SETTINGS_FAILED = 'GET_RETURN_SETTINGS_FAILED'
const PUT_RETURN_SETTINGS = 'PUT_RETURN_SETTINGS'
const PUT_RETURN_SETTINGS_SUCCESS = 'PUT_RETURN_SETTINGS_SUCCESS'
const PUT_RETURN_SETTINGS_FAILED = 'PUT_RETURN_SETTINGS_FAILED'

export const getReturnSettings = () =>
  AsyncAction<GETRMASettingsResponse>({
    type: [GET_RETURN_SETTINGS, GET_RETURN_SETTINGS_SUCCESS, GET_RETURN_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getReturnSettings()
    }
  })

export const putReturnSettings = (newValues: RMASettings) =>
  AsyncAction<GETRMASettingsResponse>({
    type: [PUT_RETURN_SETTINGS, PUT_RETURN_SETTINGS_SUCCESS, PUT_RETURN_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: requests.putReturnSettings(newValues)
    }
  })
